import AutomationService from '@/services/api/automation.services'

const state = {
    tasks: [],
    types: [],
    statuses: [],
    priorities: [],
    currentTask: null,
    isLoading: false,
}

const mutations = {
    SET_TASKS: (s, p) => (s.tasks = p),
    SET_TYPES: (s, p) => (s.types = p),
    SET_STATUSES: (s, p) => (s.statuses = p),
    SET_PRIORITIES: (s, p) => (s.priorities = p),
    SET_CURRENT_TASK: (s, p) => (s.currentTask = p),
    SET_LOADING: (s, v) => (s.isLoading = v),
    CLEAR_CURRENT_TASK: (s) => (s.currentTask = null),
}

const actions = {
    async setTasksFromCache({ commit }, tasks) {
        commit('SET_TASKS', tasks)
    },

    async getTasks({ commit }, params = {}) {
        commit('SET_LOADING', true)
        try {
            let allTasks = []
            let currentPage = 1
            let hasNextPage = true

            while (hasNextPage) {
                const { data } = await AutomationService.get('tasks', { 
                    ...params, 
                    page: currentPage 
                })
                allTasks = [...allTasks, ...(data.data || [])]
                
                hasNextPage = data.links && data.links.next !== null
                currentPage++
            }
            commit('SET_TASKS', allTasks)
            return { data: allTasks, total: allTasks.length }
        } finally {
            commit('SET_LOADING', false)
        }
    },

    async getTypes({ commit, state }) {
        if (state.types.length) return state.types
        commit('SET_LOADING', true)
        try {
            const { data } = await AutomationService.get('types')
            commit('SET_TYPES', data.data || data)
            return data
        } finally {
            commit('SET_LOADING', false)
        }
    },

    async getStatuses({ commit, state }) {
        if (state.statuses.length) return state.statuses
        commit('SET_LOADING', true)
        try {
            const { data } = await AutomationService.get('statuses')
            commit('SET_STATUSES', data.data || data)
            return data
        } finally {
            commit('SET_LOADING', false)
        }
    },

    async getPriorities({ commit, state }) {
        if (state.priorities.length) return state.priorities
        commit('SET_LOADING', true)
        try {
            const { data } = await AutomationService.get('priorities')
            commit('SET_PRIORITIES', data.data || data)
            return data
        } finally {
            commit('SET_LOADING', false)
        }
    },

    async createTask({ dispatch }, payload) {
        await AutomationService.post('tasks', payload)
    },

    async updateTask({ dispatch }, { id, data }) {
        await AutomationService.put('changeTask', id, data)
    },

    async deleteTask({ dispatch }, id) {
        await AutomationService.delete('changeTask', id)
    },

    async getTaskById({ commit }, id) {
        commit('SET_LOADING', true)
        try {
            const { data } = await AutomationService.getById('changeTask', {
                id: id,
            })
            commit('SET_CURRENT_TASK', data.data || data)
            return data
        } finally {
            commit('SET_LOADING', false)
        }
    },

    clearCurrentTask({ commit }) {
        commit('CLEAR_CURRENT_TASK')
    },
}

const getters = {
    tasks: (s) => s.tasks,
    types: (s) => s.types,
    statuses: (s) => s.statuses,
    priorities: (s) => s.priorities,
    currentTask: (s) => s.currentTask,
    isLoading: (s) => s.isLoading,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
